import {connect} from 'react-redux';
import GoogleMapsApi from './GoogleMapsApi';
import {getGoogleMapsApiKey} from '../../selectors/configSelectors';

const mapStateToProps = (state) => ({
  googleMapApiKey: getGoogleMapsApiKey(state)
});

export default connect(mapStateToProps, {})(GoogleMapsApi);



// WEBPACK FOOTER //
// ./src/components/GoogleMapsApi/GoogleMapsApiContainer.js